
import PubSub from "underpub-js";

/**
 * Sitewide
 */
var Sitewide = function(){

};

/**
 * Init
 */
Sitewide.prototype.init = function(){

    var self = this;

    this.initEvents();
    this.initSelectDropdowns();
    this.inlineSvgs();
    this.initLinkHandlers();

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function(){

    //
    // Resizing (at the start)
    //
    var windowThrottled = _.throttle(function(e){
        PubSub.publish('resize');
    }, 0, {trailing: false});
    window.addEventListener("resize", windowThrottled, false);

    //
    // Resized Event (at the end)
    //
    var windowResizeDebounce = _.debounce(function(e) {
        PubSub.publish('resized');
    }, 400);
    window.addEventListener("resize", windowResizeDebounce, false);

};

Sitewide.prototype.initLinkHandlers = function(){

    $("a[href^='tel:']").on('click', function() {

        // only fire these if the relevant tracking scripts have been set up in SEOmatic
        if(typeof gtag !== "undefined"){
            gtag('event', 'phone_call', {
                'event_category' : 'engagement'
            });
        }

        if(typeof fbq !== "undefined"){
            fbq('track', 'Contact');
        }

    });

};

Sitewide.prototype.initSelectDropdowns = function(){

    $('select').on('change', function() {

        $(this).removeClass('value-selected');

        if ($(this).val() != '')
        {
            $(this).addClass('value-selected');
        }

    });

};

Sitewide.prototype.inlineSvgs = function(){

	 var promises = [];

   /*
    * Replace all SVG images with inline SVG
    */
    $('img:not(.no-svg-replace)').filter(function() {
        return this.src.match(/.*\.svg/);
    }).each(function(){

        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img[0].src;

        if (imgURL.indexOf('?') >= 0) {
            var imgURL = imgURL + '&from-js=true';
        }
        else {
            var imgURL = imgURL + '?from-js=true';
        }

        promises.push($.ajax({
            url: imgURL,
            dataType: 'xml',
            success: function(data) {

                var $wrapperDiv = $('<div class="inline-svg-wrapper"></div>').insertBefore($img);

                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // IE doesn't scale SVG properly so we need to use a canvas object
                if($svg.attr('height') && $svg.attr('width')) {
                    var $canvas = $('<canvas class="svg-frame" height="' + $svg.attr('height') + '" width="' + $svg.attr('width') + '"></canvas>');
                }
                else {
                    var $canvas = $('<canvas class="svg-frame" height="1" width="1"></canvas>');
                }

                $wrapperDiv.append($canvas);

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }

                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // do not include height and width attributes on svg
                $svg.removeAttr('height');
                $svg.removeAttr('width');


                // Replace image with new SVG
                $wrapperDiv.append($svg);

                $img.remove();

            }
        }));

    });

	$.when(...promises).then(function(){
		PubSub.publish('Sitewide:inlineSvgs:svgReplaced');
		console.log("DONE!!");
	})

};

export default Sitewide;
